<button
    type="button"
    class="spot-link"
    [title]="text.remove"
    (click)="hideSection()"
>
  <op-icon icon-classes="icon-close icon-small"></op-icon>
</button>
